import * as types from './actionTypes';

export const setSupportContent = supportContent => ({
  type: types.SET_SUPPORT_CONTENT,
  supportContent
});

export const setSupportMenuState = isOpen => ({
  type: types.SET_SUPPORT_MENU_STATE,
  isOpen
});

export const setMobileSupportMenuState = isOpen => ({
  type: types.SET_MOBILE_SUPPORT_MENU_STATE,
  payload: {
    isOpen
  }
});

export const setSupportContentLoading = () => ({
  type: types.SET_SUPPORT_CONTENT_LOADING
});
